import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';

@Pipe({
  name: 'removeWhiteSpaces'
})
export class RemoveWhitespacesPipe implements PipeTransform {

  transform(value: string, args?: any): string {
    if (value === null) { return null }
    return value.replace(/ /g, '');
  }

}

@NgModule({
  declarations: [
    RemoveWhitespacesPipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RemoveWhitespacesPipe
  ]
})
export class RemoveWhitespacesPipeModule { }
